import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { API } from 'aws-amplify';
import { HelperService } from 'src/app/shared/services/helper_service';

@Component({
  selector: 'app-daily-check-in-bonus',
  templateUrl: './daily-check-in-bonus.page.html',
  styleUrls: ['./daily-check-in-bonus.page.scss'],
})
export class DailyCheckInBonusPage implements OnInit {
  @Input() dailystreaklist: any
  daysConfig = [];
  currentDay;
  currentdayCoins ;
  constructor(private modal: ModalController,
    private helperService : HelperService) { }

  ngOnInit() {
    console.log(this.dailystreaklist);
    this.daysConfig = this.dailystreaklist.daysConfig ;
    this.currentDay = this.dailystreaklist.currentDay ;
    console.log(this.daysConfig);
    for(let d of this.daysConfig){
      if(d.dayNumber == this.currentDay){
        console.log(d.amount);
        this.currentdayCoins = d.amount;
        console.log("same day");
        
      }
    }
    
    
    // this.getDailyStrekcoins();
  }
  addDailyStrekcoins(){
    console.log(this.currentDay,this.currentdayCoins)
    const apiName = 'profile';
    const path = `/profiles/daily-streak`;
    const myInit = {
        headers: {},
        response: true,
        body: {
          dayNumber:this.currentDay,
          amount : this.currentdayCoins
        },
    };
    API.post(apiName, path, myInit)
      .then(response => {
        console.log(response.data.message);
       
        this.modal.dismiss(true);
        this.helperService.presentToast(response?.data?.message);
      })
      .catch(error => {
        console.log(error);
      });    
  }

}
